// extracted by mini-css-extract-plugin
module.exports = {"stickyCalendar":"StickyCalendar_stickyCalendar__bk_Xh"};